import { useEffect } from 'react';
import './Modal.css';

// Shared popup shell used across the customer portal (Add Product, Add
// Comments, error alerts, etc.) so every dialog gets the same backdrop,
// card, and background-scroll-lock behavior for free.
export default function Modal({
  open,
  title,
  subtitle,
  onClose,
  children,
  footer,
  headerActions,
  maxWidth,
  className = '',
}) {
  useEffect(() => {
    if (!open) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="customer-portal-modal-backdrop" onClick={onClose}>
      <div
        className={`customer-portal-modal-card ${className}`.trim()}
        style={maxWidth ? { maxWidth } : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="customer-portal-modal-card__header">
            <div>
              <div className="customer-portal-modal-card__title">{title}</div>
              {subtitle && <div className="customer-portal-modal-card__subtitle">{subtitle}</div>}
            </div>
            <div className="customer-portal-modal-card__header-actions">
              {headerActions}
              <button type="button" className="customer-portal-modal-card__close" onClick={onClose} aria-label="Close">
                ✖
              </button>
            </div>
          </div>
        )}

        {children}

        {footer && <div className="customer-portal-modal-card__footer">{footer}</div>}
      </div>
    </div>
  );
}
